import sample_01 from './idealProtectExtra.jpg';

export const idealProtectExtraImpressions = {
    sample_01,
};
